import styled from 'styled-components';
import BudgetSummary from './BudgetSummary';
import { RIGHT_SECTION_LABEL } from '../../constants';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  margin-bottom: 16px;
  margin-top: 16px;
`;

const Header = styled.h2`
  margin-bottom: 16px;
  margin-top: 16px;
`;

const CampaignBudgets = () => {
  const { detail } = useAppSelector((state: RootState) => state);

  return (
    <div>
      <Header>Campaign Deliverables</Header>
      <StyledContainer>
        <BudgetSummary
          label={RIGHT_SECTION_LABEL.BUDGET}
          usedValue={detail.usedBudget}
          totalValue={detail.grossBudget}
          durations={detail.campaignDurations}
        />
        <BudgetSummary
          label={RIGHT_SECTION_LABEL.TARPS}
          usedValue={detail.usedTarps}
          totalValue={detail.targetTarp}
          durations={detail.campaignDurations}
        />
        <BudgetSummary
          label={RIGHT_SECTION_LABEL.IMPACT}
          usedValue={detail.usedImpacts}
          totalValue={detail.targetImpact}
          durations={detail.campaignDurations}
        />
      </StyledContainer>
    </div>
  );
};

export default CampaignBudgets;
